import { useEffect, useState } from 'react';
import { NavIconFlyout, useMediaQuery, tokens } from '@wapharma/design-system';
import { InboxTwotone } from '../icons/mxNavTwotone';
import { MX_NAV_ICON } from '../lib/mxTwotoneIcon';
import { useInboxCount } from '../contexts/InboxCountContext';
import { useInboxBadgeCounts } from '../hooks/useInboxBadgeCounts';
import { INBOX_OPEN_EVENT } from '../lib/inboxOpenEvent';
import { InboxPopoverContent, type InboxSelectedDetail } from './InboxPopoverContent';

export function InboxNavFlyout() {
  const narrow = useMediaQuery(tokens.media.mdMax);
  const inboxIcon = narrow ? { ...MX_NAV_ICON, size: 18 } : MX_NAV_ICON;
  const inboxBadge = useInboxBadgeCounts();
  const { count: inboxTotal, unseenCount } = useInboxCount();
  const [selectedDetail, setSelectedDetail] = useState<InboxSelectedDetail | null>(null);
  const [openSignal, setOpenSignal] = useState(0);
  const detailOpen = selectedDetail != null;

  useEffect(() => {
    const onOpen = () => setOpenSignal((s) => s + 1);
    window.addEventListener(INBOX_OPEN_EVENT, onOpen);
    return () => window.removeEventListener(INBOX_OPEN_EVENT, onOpen);
  }, []);

  return (
    <NavIconFlyout
      openSignal={openSignal}
      icon={<InboxTwotone {...inboxIcon} aria-hidden />}
      label="Boîte de réception"
      count={inboxTotal > 0 ? inboxTotal : undefined}
      unseenCount={unseenCount > 0 ? unseenCount : undefined}
      panelVariant={detailOpen ? 'expanded' : 'default'}
      keepOpen={detailOpen}
      onRequestClose={() => setSelectedDetail(null)}
      triggerVariant={narrow ? 'chrome' : 'ghost'}
    >
      <InboxPopoverContent
        selectedDetail={selectedDetail}
        onSelectDetail={setSelectedDetail}
        isImportJobAcked={inboxBadge.isImportJobAcked}
        ackImportJob={inboxBadge.ackImportJob}
        isImageResolveJobAcked={inboxBadge.isImageResolveJobAcked}
        ackImageResolveJob={inboxBadge.ackImageResolveJob}
        isImageResolveQueueSeen={inboxBadge.isImageResolveQueueSeen}
        ackImageResolveQueue={inboxBadge.ackImageResolveQueue}
      />
    </NavIconFlyout>
  );
}
